export const PageHero = ({ eyebrow, title, italic, subtitle, children }) => (
  <section
    data-testid="page-hero"
    className="relative pt-40 pb-20 md:pt-52 md:pb-28 px-6 md:px-12 border-b border-white/5 overflow-hidden"
    style={{
      background:
        "radial-gradient(circle at 20% 30%, rgba(197,160,89,0.10), transparent 45%), radial-gradient(circle at 80% 20%, rgba(197,160,89,0.05), transparent 40%), #0a1128",
    }}
  >
    <div className="max-w-5xl mx-auto">
      {eyebrow && (
        <div className="text-[10px] tracking-[0.5em] text-[#c5a059] uppercase mb-6">{eyebrow}</div>
      )}
      <h1 className="font-serif-display text-4xl md:text-6xl lg:text-7xl font-light leading-[1.1] mb-6">
        {title}
        {italic && (
          <>
            {" "}<em className="italic gold-gradient">{italic}</em>
          </>
        )}
      </h1>
      {subtitle && (
        <p className="text-base md:text-lg text-white/65 max-w-2xl leading-relaxed">
          {subtitle}
        </p>
      )}
      {children}
    </div>
  </section>
);
